import { Injectable, inject } from '@angular/core';

import { UrlParam } from '@frontend/sports/navigation/core/feature/url-builder';
import { MarketUrlParam, UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { myBetsTrackingConstants } from '../models/my-bets-tracking.model';

@Injectable()
export class MyBetsTrackingService {
    private trackingService = inject(TrackingService);
    private urlHelperService = inject(UrlHelperService);

    trackMyBetsScoreboard(eventAbsUrl: string, activeMybetTab?: BetslipListType) {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: trackingConstants.BETTING,
            [trackingConstants.COMPONENT_LABEL_EVENT]: myBetsTrackingConstants.MY_BETS,
            [trackingConstants.COMPONENT_ACTION_EVENT]: trackingConstants.EVENT_CLICK,
            [trackingConstants.COMPONENT_POSITION_EVENT]: activeMybetTab?.toLowerCase(),
            [trackingConstants.COMPONENT_LOCATION_EVENT]: myBetsTrackingConstants.MY_BETS,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: myBetsTrackingConstants.SCOREBOARD,
            [trackingConstants.COMPONENT_URL_CLICKED]: eventAbsUrl,
        });
    }

    getRoutePath(param: UrlParam, market?: MarketUrlParam): string {
        const evtRelativeUrl = this.urlHelperService.getEventUrl(param, market);
        return this.urlHelperService.getAbsolute(evtRelativeUrl);
    }
}
